<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab title="Pessoas" active>
          <template #title> <i class="icofont-list"></i> Pessoas </template>
          <div class="info-table py-4">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRed"
              />
            </div>
            <div class="info-table-item">
              <vue-select
                v-model="selectedFilterBoasPraticas"
                :options="optionsFilterBoasPraticasLista"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticas"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="info-table-item">
              <DownloadFiles
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="saude-da-mulher"
              />
            </div>
          </div>
          <TabelaCadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            :selectedFilterBoasPraticas="selectedFilterBoasPraticas"
            @filterSearch="filterSearch"
          />
        </b-tab>

        <b-tab title="Percentual">
          <template #title>
            <i class="icofont-mathematical-alt-1"></i> Percentual
          </template>

          <div class="row mt-4">
            <div class="col-md-4">
              <vue-select
                v-model="selectedFilterBoasPraticasTabelaPercentual"
                :options="optionsFilterBoasPraticasPercentual"
                label="label"
                placeholder="Boas práticas"
                :clearable="true"
                @input="onChangeFilterBoasPraticasPercentual"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>

          <TabelaPercentual
            :loading="loading"
            :municipio="dadosPercentualMunicipio"
            :equipe="dadosPercentualEquipe"
            :micro_area="dadosPercentualMicroArea"
            :selectedEquipe="equipe"
            :selectedMicroArea="microArea"
            :selectedFilterBoasPraticas="
              selectedFilterBoasPraticasTabelaPercentual
            "
          />
          <GraficoPercentual
            :equipe="equipe"
            :micro_area="microArea"
            ref="graficoPercentual"
          />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Subtitle from './components/Subtitle.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import {
  dataFields,
  optionsFilterBoasPraticasLista,
  optionsFilterBoasPraticasPercentual,
} from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './components/TabelaCadastros.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'
import TabelaPercentual from './components/TabelaPercentual.vue'
import GraficoPercentual from './components/GraficoPercentual.vue'

export default {
  name: 'SaudeDaMulher',
  components: {
    Subtitle,
    PulseLoader,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    TabelaCadastros,
    SelectsV2,
    TabelaPercentual,
    GraficoPercentual,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      equipe: '',
      microArea: '',
      microAreas: [],
      cadastros: [],
      cadastrosOriginais: [],
      dadosPercentualMunicipio: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualEquipe: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosPercentualMicroArea: {
        numerador: 0,
        denominador: 0,
        resultado: 0,
        classificacacao: '',
      },
      dadosTabelaPercentual: [],
      dadosGraficoPercentual: [],
      loading: false,
      tabsActive: 0,
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      filterSearchTable: false,
      dataFields: { ...dataFields },
      selectedFilterBoasPraticas: null,
      selectedFilterBoasPraticasTabelaPercentual: {
        label: 'Resultado indicador',
        value: null,
        key: 'resultado-indicador',
        key_percentual: 'resultado-indicador',
      },
      optionsFilterBoasPraticasLista: [...optionsFilterBoasPraticasLista],
      optionsFilterBoasPraticasPercentual: [
        ...optionsFilterBoasPraticasPercentual,
      ],
    }
  },

  computed: {
    displayedCadastros() {
      if (this.filterSearchTable) return this.filterSearchTable

      const resultado = Filter.filtro(
        this.cadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.selectedFilterBoasPraticas
      )
      return resultado || []
    },
  },

  methods: {
    filtros(vermelho, verde) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.setRed = vermelho
      this.exibirCadastrosVermelhos = vermelho
      this.exibirCadastrosVerdes = verde && !vermelho
    },

    filterSearch(item) {
      this.filterSearchTable = item.filter || false
    },

    handleExibirVermelhos(valor) {
      this.filtros(valor, false)
    },

    handleExibirVerdes(valor) {
      this.filtros(false, valor)
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) this.$refs.table.search = ''

      this.equipe = event
      this.microArea = ''
      this.resetDadosMicroArea()

      if (event) {
        this.tabsActive = 0
        this.resetCadastros()
        await this.buscarCadastrosPorEquipe()
      } else {
        this.resetDadosEquipe()
        this.resetCadastros()
      }

      this.setarPercentualEquipe()
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) this.$refs.table.search = ''
      this.tabsActive = 0
      this.microArea = event?.micro_area || ''
      this.resetDadosMicroArea()

      if (event && this.microArea) {
        this.loading = true
        await this.buscarCadastrosMicroArea()
        this.loading = false
      } else {
        await this.onChangeEquipe(this.equipe)
      }

      this.setarPercentualMicroArea()
    },

    async buscarCadastrosPorEquipe() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.filtros(true, false)
      }
      this.loading = false
    },

    async buscarCadastrosMicroArea() {
      this.loading = true
      const resposta = await Functions.getCadastrosPorMicroArea(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap,
        this.microArea
      )
      if (resposta) {
        this.cadastros = resposta
        this.cadastrosOriginais = resposta
        this.filtros(true, false)
      }
      this.loading = false
    },

    onChangeFilterBoasPraticas(item) {
      this.handleExibirVermelhos(true)
    },

    onChangeFilterBoasPraticasPercentual(item) {
      this.setarPercentualMunicipio()
      if (this.equipe != '') {
        this.setarPercentualEquipe()
      }
      if (this.microArea != '') {
        this.setarPercentualMicroArea()
      }
    },

    setarPercentualMunicipio() {
      const resultado = Functions.percentualMunicipio(
        this.dadosGraficoPercentual,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualMunicipio, resultado)
      this.$refs.graficoPercentual.serieHistoricaMunicipio(
        this.dadosGraficoPercentual
      )
    },

    setarPercentualEquipe() {
      const resultado = Functions.percentualEquipe(
        this.dadosGraficoPercentual,
        this.equipe.ine_esf_eap,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualEquipe, resultado)
      this.$refs.graficoPercentual.serieHistoricaEquipe(
        this.dadosGraficoPercentual,
        this.equipe
      )
    },

    async setarPercentualMicroArea() {
      if (!this.microArea) return
      const resultado = Functions.percentualMicroArea(
        this.dadosGraficoPercentual,
        this.equipe.ine_esf_eap,
        this.microArea,
        this.selectedFilterBoasPraticasTabelaPercentual
      )
      Object.assign(this.dadosPercentualMicroArea, resultado)
      this.$refs.graficoPercentual.serieHistoricaMicroArea(
        this.dadosGraficoPercentual,
        this.equipe,
        this.microArea
      )
    },

    resetCadastros() {
      this.cadastros = []
      this.cadastrosOriginais = []
    },

    resetDadosEquipe() {
      this.equipe = ''
      this.dadosPercentualEquipe = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    resetDadosMicroArea() {
      this.dadosPercentualMicroArea = {
        numerador: 0,
        denominador: 0,
        resultado: 0,
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.microArea,
        this.selectedFilterBoasPraticas
      )
    },

    async init() {
      try {
        const response2 = await this.$api.get(
          `/app/v2/serie-historica/${this.$store.state.cod_ibge}/indicador/[47]`
        )
        this.dadosGraficoPercentual = response2.data
        this.setarPercentualMunicipio()
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            this.buscarCadastrosPorEquipe()
            this.setarPercentualEquipe()
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            this.setarPercentualEquipe()
          }
          this.microArea = this.$store.state.micro_area
          this.buscarCadastrosMicroArea()
          this.setarPercentualMicroArea()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },

  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style scoped></style>
